import React from 'react';

const BasicInfoColumn = (params: any) => {
    if (!params.value) return <></>;
    const MAX_WORDS_PER_LINE = 10;

    // First split by newlines to preserve explicit line breaks
    const paragraphs = params.value.split('\n');
    const allLines: string[] = [];

    paragraphs.forEach((paragraph: string) => {
        if (paragraph.trim() === '') {
            // Add empty line for empty paragraphs
            allLines.push('');
        } else {
            // Split paragraph into words and create lines based on MAX_WORDS_PER_LINE
            const words = paragraph.split(' ');
            for (let i = 0; i < words.length; i += MAX_WORDS_PER_LINE) {
                const line = words.slice(i, i + MAX_WORDS_PER_LINE).join(' ');
                allLines.push(line);
            }
        }
    });

    return (
        <>
            {allLines.map((line, index) => (
                <React.Fragment key={index}>
                    {line}
                    <br />
                </React.Fragment>
            ))}
        </>
    );
};

export default BasicInfoColumn;
